import { HttpInterceptorFn } from '@angular/common/http';
import { fetchAuthSession } from 'aws-amplify/auth';
import { from, switchMap, catchError } from 'rxjs';
import { environment } from '../environments/environment';

/**
 * Il token va solo alle nostre API. Agli altri domini (es. URL presigned S3) non va inviato:
 * sarebbe una fuga del JWT, e S3 rifiuta le richieste che hanno sia la firma nell'URL sia l'header Authorization.
 */
function isRichiestaApi(url: string): boolean {
  if (!/^https?:\/\//i.test(url)) return true; // URL relativo: stesso dominio della UI
  return !!environment.apiUrl && url.startsWith(environment.apiUrl);
}

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  if (!isRichiestaApi(req.url)) return next(req);

  return from(fetchAuthSession()).pipe(
    switchMap(session => {
      const token = session.tokens?.accessToken?.toString();
      if (token) {
        req = req.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
          },
        });
      }
      return next(req);
    }),
    catchError(err => {
      // Se il token è scaduto e il refresh fallisce
      console.error('Errore recupero token', err);
      return next(req);
    }),
  );
};
